import { createSlice } from "@reduxjs/toolkit"
import {
  IPatientReportResponse,
  IPatientCaseReportResponse,
} from "@/modules/Patient/Overview/components/patientReportTables/patient-report.types"
import { fetchPatientReport, fetchPatientCaseReport } from "./patientReportThunkApi"

interface IPatientReportState {
  patientReport: IPatientReportResponse | null
  loading: "idle" | "pending" | "succeeded" | "failed"
  reportErrorCode: string | null
  patientCaseReport: IPatientCaseReportResponse | null
  caseReportLoading: "idle" | "pending" | "succeeded" | "failed"
  caseReportErrorCode: string | null
}

const initialState: IPatientReportState = {
  patientReport: null,
  loading: "idle",
  reportErrorCode: null,
  patientCaseReport: null,
  caseReportLoading: "idle",
  caseReportErrorCode: null,
}

export const patientReportSlice = createSlice({
  name: "patientReport",
  initialState,
  reducers: {
    resetPatientReport(state) {
      state.patientReport = null
      state.loading = "idle"
      state.caseReportErrorCode = null
    },
    resetPatientCaseReport(state) {
      state.patientCaseReport = null
      state.caseReportLoading = "idle"
      state.caseReportErrorCode = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPatientReport.pending, (state) => {
      state.loading = "pending"
    })
    builder.addCase(fetchPatientReport.fulfilled, (state, action) => {
      state.patientReport = action.payload
      state.loading = "succeeded"
    })
    builder.addCase(fetchPatientReport.rejected, (state, action) => {
      state.patientReport = null
      state.loading = "failed"
      state.caseReportErrorCode = (action.payload as any)?.data?.errors?.[0]?.error_code ?? null
    })
    builder.addCase(fetchPatientCaseReport.pending, (state) => {
      state.caseReportLoading = "pending"
    })
    builder.addCase(fetchPatientCaseReport.fulfilled, (state, action) => {
      state.patientCaseReport = action.payload
      state.caseReportLoading = "succeeded"
    })
    builder.addCase(fetchPatientCaseReport.rejected, (state, action) => {
      state.patientCaseReport = null
      state.caseReportLoading = "failed"
      state.caseReportErrorCode = (action.payload as any)?.data?.errors?.[0]?.error_code ?? null
    })
  },
})

export const { resetPatientReport, resetPatientCaseReport } = patientReportSlice.actions
